<template>
  <button @click.prevent="trigger" :disabled="disabled"><slot></slot></button>
</template>
<script>
export default {
  name: "SubmitTriggerButton",
  props: ["eventToTrigger", "eventId"],
  data: function() {
    return {
      disabled: false
    };
  },
  methods: {
    trigger: function() {
      this.disabled = true;
      this.$eventHub.$emit(this.eventToTrigger, this.eventId);
      setTimeout(this.cancel, 30000);
    },
    cancel: function() {
      this.disabled = false;
    }
  },
  mounted: function() {
    this.$eventHub.$on("validationError", this.cancel);
  }
};
</script>
